import { render, staticRenderFns } from "./ScenicMenu.vue?vue&type=template&id=ffbbabfa&scoped=true"
import script from "./ScenicMenu.vue?vue&type=script&lang=js"
export * from "./ScenicMenu.vue?vue&type=script&lang=js"
import style0 from "./ScenicMenu.vue?vue&type=style&index=0&id=ffbbabfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbbabfa",
  null
  
)

export default component.exports